import { render } from "./QuoteDisplay.vue?vue&type=template&id=7b10a05e"
import script from "./QuoteDisplay.vue?vue&type=script&lang=js"
export * from "./QuoteDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__